/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiTracksIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор трека")
    })

/**
 * @description Трек удален
 */
export const deleteApiTracksId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiTracksId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiTracksId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiTracksId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Трек не найден
 */
export const deleteApiTracksId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiTracksId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiTracksIdMutationResponseSchema = z.lazy(() => deleteApiTracksId200Schema)